import React, { Component } from "react";

export default class step1 extends Component {
  render() {
    return (
      <div className="step-container">
        <div className="subtitle">Step 3</div>
        <div className="step-name">
          Step3 and send your request
        </div>
      </div>
    );
  }
}
